import CONST_COMPONENT from '../const/component'

import {
  KeywordComponent,
  GetStartedComponent,
  MessengerEngagementPluginComponent,
} from '../functions/default-component'

import {
  getConnectionTypeOncePicked,
  printMessageForDevelopmentMode,
  disableZoomForDoubleClick, 
  doNotShowContextMenu,
  doNotLetDeleteReferenceNode,
  warnForIncompatibleConnection,
  hideModalIfNodeRemoved,
  warnIfConnectionLimitCrosses,
  
  hideNewPostbackNodeAndModalElementsIfConnectedWithSequenceSingle,
  showNewPostbackNodeAndModalElementsIfConnectedWithSequenceSingle,

  showReferenceModalElementsIfActionButtonHasSpecificValue,
  hideReferenceModalElementsIfActionButtonHasSpecificValue,
  
  displayComponentListAndCreateNodeOnClick,

  toggleOutputConnectionOfNewQuestionOnCreated,
  toggleOutputConnectionOfNewQuestionOnRemoved,
  changeUniqueIdOnCloneNode,
  deleteChildrenNodesWhenDeletingParentNode,
} from '../listeners'

const sequence_addon = !! window.xitFlowBuilderData.sequence_addon
const messenger_bot_condition = !! window.xitFlowBuilderData.messenger_bot_condition
const user_input_flow_addon = !! window.xitFlowBuilderData.user_input_flow_addon
const instagram_bot_addon = !! window.xitFlowBuilderData.instagram_addon

const hideFromContextMenu = [CONST_COMPONENT.POSTBACK]
const hideCloneMenuFromContextMenu = [CONST_COMPONENT.COMPONENT_LIST]

if (! sequence_addon) {
  hideFromContextMenu.push(CONST_COMPONENT.SEQUENCE)
  hideFromContextMenu.push(CONST_COMPONENT.SEQUENCE_SINGLE)
}

if(! user_input_flow_addon) {
  hideFromContextMenu.push(CONST_COMPONENT.USER_INPUT_FLOW)
  hideFromContextMenu.push(CONST_COMPONENT.USER_INPUT_FLOW_SINGLE)
}

if(! messenger_bot_condition) {
  hideFromContextMenu.push(CONST_COMPONENT.CONDITION)
}

const config = {
  hideFromContextMenu: hideFromContextMenu,
  hideCloneMenuFromContextMenu: hideCloneMenuFromContextMenu,

  undroppableElements: [
    'xitFbGrip', 
    'fbDockmenu', 
    'hoverNodeCard'
  ],

  ignoreNodesWhileCheckingData: [
    CONST_COMPONENT.CONDITION,
  ],

  defaultComponentMappingTypeToClass: {
    'keyword': KeywordComponent,
    'get-started': GetStartedComponent,
    'messenger-engagement': MessengerEngagementPluginComponent,
  },

  eventsAndListeners: [
    { event: 'connectionpick', listener: getConnectionTypeOncePicked },
    { event: 'warn', listener: printMessageForDevelopmentMode },
    { event: 'zoom', listener: disableZoomForDoubleClick },
    { event: 'showcontextmenu', listener: doNotShowContextMenu },
    { event: 'noderemove', listener: doNotLetDeleteReferenceNode },
    { event: 'connectioncreate', listener: warnForIncompatibleConnection },
    { event: 'noderemoved', listener: hideModalIfNodeRemoved },

    { event: 'connectioncreated', listener: warnIfConnectionLimitCrosses },

    { event: 'connectioncreated', listener: hideNewPostbackNodeAndModalElementsIfConnectedWithSequenceSingle },
    { event: 'connectionremoved', listener: showNewPostbackNodeAndModalElementsIfConnectedWithSequenceSingle },

    { event: 'connectioncreated', listener: showReferenceModalElementsIfActionButtonHasSpecificValue },
    { event: 'connectionremoved', listener: hideReferenceModalElementsIfActionButtonHasSpecificValue },

    { event: 'connectioncreated', listener: toggleOutputConnectionOfNewQuestionOnCreated },
    { event: 'connectionremoved', listener: toggleOutputConnectionOfNewQuestionOnRemoved },
    
    { event: 'connectiondrop', listener: displayComponentListAndCreateNodeOnClick },
    
    { event: 'nodeclone', listener: changeUniqueIdOnCloneNode },

    { event: 'nodedelete', listener: deleteChildrenNodesWhenDeletingParentNode },
  ],
}

if (instagram_bot_addon) {
  config.ignoreNodesWhileCheckingData.push(CONST_COMPONENT.CAROUSEL)
}

export default config